<template>
  <div class="mood-feedback">
    <v-item-group v-model="filterEmotion" v-if="dbStats">
      <v-container class="pa-0">
        <v-row>
          <v-col v-for="n in [-2, -1, 0, 1, 2]" :key="'emotion-' + n">
            <v-item v-slot:default="{ active, toggle }">
              <v-card
                :dark="active"
                class="d-flex flex-column justify-center"
                height="200"
                outlined
                @click="toggle"
              >
                <div class="display-3">{{ getEmojiForEmotion(n) }}</div>
                <div class="display-2 font-weight-bold">{{ stats[n] }}</div>
              </v-card>
            </v-item>
          </v-col>
        </v-row>
      </v-container>
    </v-item-group>

    <div v-for="item in filteredMoodFeedback" v-bind:key="item.id">
      <md-card md-dense>
        <md-card-header>
          <md-card-header-text>
            <div class="md-title">
              {{ item.study }}
              <span>{{ getEmojiForEmotion(item.emotion) }}</span>
            </div>
            <div class="md-subhead">{{ item.timestamp | moment("from") }}</div>
          </md-card-header-text>

          <md-menu md-size="big" md-direction="bottom-end">
            <md-chip class="version-nb"
              >Version <strong>{{ item.version }}</strong></md-chip
            >
            <md-button
              class="md-icon-button md-primary"
              @click="archive(item.id)"
              v-if="userRole === 'admin'"
            >
              <md-icon>archive</md-icon>
            </md-button>
          </md-menu>
        </md-card-header>

        <md-card-content>
          {{ item.comments }}
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>

<style scoped>
.mood-feedback {
  text-align: center;
}
.mood-feedback .md-card {
  width: 100%;
  max-width: 600px;
  display: inline-block;
  vertical-align: top;
  margin: 5px 0px;
  text-align: left;
}
.caption {
  color: #999;
}

.version-nb {
  margin-right: 10px;
  margin-top: 4px;
}

.md-title span {
  font-size: 30px;
}
</style>

<script>
import { mapState } from "vuex";

export default {
  name: "mood-feedback",
  data: () => ({
    filterEmotion: null
  }),
  computed: {
    ...mapState(["dbMoodFeedback", "dbStats", "userRole"]),
    sortedMoodFeedback() {
      let sorted = [];
      for (let key in this.dbMoodFeedback) {
        let item = this.dbMoodFeedback[key];
        item.id = key;
        sorted.unshift(item);
      }
      return sorted.sort((a, b) => a.timestamp - b.timestamp);
    },
    stats() {
      return this.dbStats.MoodFeedback;
    },
    filteredMoodFeedback() {
      const curEmotion =
        this.filterEmotion != null ? Number(this.filterEmotion) - 2 : null;

      let sorted = [];
      for (let key in this.dbMoodFeedback) {
        let item = this.dbMoodFeedback[key];
        item.id = key;

        if (curEmotion === null || item.emotion === curEmotion) {
          sorted.unshift(item);
        }
      }

      return sorted;
    }
  },
  methods: {
    archive(itemId) {
      this.$store.dispatch("archiveMoodFeedback", itemId);
    },
    getEmojiForEmotion(emotion) {
      switch (emotion) {
        case -2:
          return "😡";
        case -1:
          return "😞";
        case 0:
          return "😐";
        case 1:
          return "🙂";
        case 2:
          return "😁";
      }
    }
  },
  created() {
    this.$store.dispatch("fetchMoodFeedback");
  }
};
</script>
